/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useContext,
  useRef,
  useEffect,
  useMemo,
} from 'react';
import { css, jsx } from '@emotion/core';
import { colors, getButtonFocus } from 'styles/variables';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { interactionContext } from './interactionContext';
import { useSelector } from 'react-redux';

import pubSub, { usePubSub } from 'services/pubSub';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

const MatchDrag = props => {
  const {
    draggableId,
    isDragDisabled = false,
    isDropDisabled = false,
    dropZoneColor,
    style,
    children,
  } = props;

  const context = useContext(interactionContext);

  const {
    panelBackground = lPink,
    panelBackgroundDragging = 'rgba(0, 0, 0, 0.5)',
    textColorDragging = '#fff',
    panelWidth = 250,
    panelHeight = 250,
  } = context.props;

  const mediaType = children[0].props.child;

  // this used as the key to have the fricken image update
  // grabbing the src off the img directly from props doesn't kick in
  // so. going to the SOURCE of the src
  const keyFromSrc =
    window.dev() &&
    useSelector(
      (state: any) => state.blocks[children[0].props.children[1].props.id].props
    ).src;

  const [hoverHilite, publish] = usePubSub(
    `MATCHING_INTERACTION_FEEDBACK_${context.id}`
  );

  const hover =
    hoverHilite &&
    hoverHilite.draggableId === draggableId &&
    hoverHilite.eventType === 'mouseOver';

  // if (hoverHilite && hoverHilite.draggableId === draggableId) {
  //   // console.log(hoverHilite);
  //   console.log(hoverHilite.eventType, draggableId);
  // }

  return (
    <Droppable
      droppableId={`drop_${Math.random()}`}
      type="drop"
      isDropDisabled={true}
    >
      {provided => (
        <div
          ref={provided.innerRef}
          className="droppable-container"
          css={css`
            position: relative;
            width: ${panelWidth}px;
            height: ${panelHeight}px;
            margin: 10px;
            text-align: center;
            background: ${'transparent' || '#fff' || lGrey1};
            border-radius: 5px;
          `}
          style={style}
        >
          <Draggable
            key={keyFromSrc}
            draggableId={`drag_${draggableId}`}
            index={0}
            isDragDisabled={isDragDisabled}
          >
            {(provided, snapshot) => {
              return (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  css={css`
                    width: ${panelWidth}px;
                    height: ${panelHeight}px;
                    text-align: center;
                    ${isDragDisabled &&
                      `.draggable-content {
            box-shadow: 0 0 0 1px ${lGrey2};
          }`}

                    border-radius: 5px;
                    ${!snapshot.isDragging &&
                      `&:focus {
                              //
                              ${getButtonFocus(
                                ['#fff', '#ffffff'].includes(panelBackground)
                                  ? lGrey0
                                  : panelBackground
                              )}
                            }`}
                  `}
                  style={{
                    ...provided.draggableProps.style,
                  }}
                >
                  <div
                    id={draggableId}
                    className="draggable-content"
                    css={css`
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: ${panelWidth}px;
                      height: ${panelHeight}px;
                      padding: 10px;
                      padding: ${mediaType === 0 ? '10px' : '0px'};
                      border-radius: 5px;
                      background: ${snapshot.isDragging
                        ? panelBackgroundDragging
                        : panelBackground};
                      box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
                      transition: background 0.2s, box-shadow 0.2s;
                      overflow: hidden;
                      & > div > div {
                        border-radius: 5px;
                      }
                      * {
                        ${snapshot.isDragging && `color: ${textColorDragging};`}
                      }
                      ${!window.dev() &&
                        `
                          user-select: none;
                          // pointer-events: none;
                      `}

                      ${window.dev() &&
                        hover &&
                        `
                      transition: border 0.3s;
                      border: 1px solid ${lPink};
                      `}
                    `}
                    // onTouchStart={e => {
                    //   e.currentTarget.style.boxShadow = `0 0 20px rgba(0, 0, 0, 0.6)`;
                    // }}
                    // onTouchEnd={e => {
                    //   e.currentTarget.style.boxShadow = `0 0 15px rgba(0, 0, 0, 0.3)`;
                    // }}
                  >
                    {children}
                  </div>
                </div>
              );
            }}
          </Draggable>
        </div>
      )}
    </Droppable>
  );
};

export default MatchDrag;
